import { z } from 'zod';
import { CustomerSchema } from './customer.dto';
import { inferApiResultSchema } from './infer-api';

export const IdeaCommentsSchema = z.object({
  id: z.number(),
  ideaId: z.number(),
  commenterId: z.string().nullish(),
  comment: z.string(),
  createdAt: z.date(),
  updatedAt: z.date().nullish(),
  internal: z.boolean(),
  customerId: z.number().nullish(),
  contactId: z.number().nullish(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  deletedAt: z.date().nullish(),
  archivedAt: z.date().nullish(),
});
export type IdeaCommentsDto = z.infer<typeof IdeaCommentsSchema>;

export const GetIdeaCommentResponseSchema = inferApiResultSchema(IdeaCommentsSchema);
export type GetIdeaCommentResponseDto = z.infer<typeof GetIdeaCommentResponseSchema>;

export const GetIdeaCommentsResponseSchema = inferApiResultSchema(z.array(IdeaCommentsSchema));
export type GetIdeaCommentsResponseDto = z.infer<typeof GetIdeaCommentsResponseSchema>;

export const CreateIdeaCommentSchema = IdeaCommentsSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  firstName: true,
  lastName: true,
  email: true,
  deletedAt: true,
  archivedAt: true,
}).extend({
  customerId: z.number().nullish().default(null),
  contactId: z.number().nullish().default(null),
});
export type CreateIdeaCommentDto = z.infer<typeof CreateIdeaCommentSchema>;

export const CreateIdeaCommentResponseSchema = inferApiResultSchema(IdeaCommentsSchema);
export type CreateIdeaCommentReponseDto = z.infer<typeof CreateIdeaCommentResponseSchema>;

export const CustomerLeanSchema = CustomerSchema.omit({
  allowedEmailDomains: true,
});

export const UpdateIdeaCommentSchema = IdeaCommentsSchema.omit({
  id: true,
  ideaId: true,
  commenterId: true,
  customerId: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export type UpdateIdeaCommentDto = z.infer<typeof UpdateIdeaCommentSchema>;

/**
 * What an idea-comment edit may change. `UpdateIdeaCommentSchema` above is a partial of the whole
 * row, so it also admits `contactId`, `deletedAt` and `archivedAt`: lifecycle timestamps belong to
 * the `/archive`, `/restore` and delete routes, which emit their own activity log, and `contactId` is
 * the ownership key for portal comment edits. It stays wide only because the portal client sends
 * `contactId` on every edit and narrowing it would reject those requests.
 */
export const UpdateIdeaCommentFieldsSchema = UpdateIdeaCommentSchema.pick({
  comment: true,
  internal: true,
});

export type UpdateIdeaCommentFieldsDto = z.infer<typeof UpdateIdeaCommentFieldsSchema>;

export const GetIdeaCustomersResponseSchema = inferApiResultSchema(z.array(CustomerLeanSchema));
export type GetIdeaCustomersResponseDto = z.infer<typeof GetIdeaCustomersResponseSchema>;
